import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { chains, wagmiConfig } from './App';
import reportWebVitals from './reportWebVitals';
import { WagmiConfig } from 'wagmi';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import ReactGA from 'react-ga'

ReactGA.initialize('G-FYNLK6ZV77')

ReactGA.event({
  category: 'Button',
  action: 'Click',
  label: 'Load'
});

ReactGA.event({
  category: 'Button',
  action: 'Click',
  label: 'Sign Transactions(s)'
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <WagmiConfig config={wagmiConfig}>
    <RainbowKitProvider chains={chains}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </RainbowKitProvider>

  </WagmiConfig>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
